import axios from 'axios'
import constants from '../constants'

export default function init() {
  console.log('multi-tenant init')
}

export async function requestBillingUsage(postData, app) {
  const URL = `${constants.customerDomain}apps/${app.id}/usage`;
  console.log(postData)

  try {
    const ccBearerToken = localStorage.getItem('ccBearerToken')
    if (ccBearerToken) {
      const res = await axios.post(URL, postData, {
        headers: {
          Authorization: `Bearer ${ccBearerToken}`,
        },
      })
        return res.data
    }
  } catch (error) {
    return error.response.data
  }
  return false // Indicates ccBearerToken was not present in the local storage
}
